import uniqueId from "lodash.uniqueid";

const getUniqueID = (item) => {
	return uniqueId(`item-${item}`);
};

export { getUniqueID };
